(function () {
  var LEGACY_CLEAR = {
    希望配送日: '',
    お届け希望時間: '',
    date: ''
  };

  function cartUpdateUrl() {
    if (!window.theme || !theme.routes || !theme.routes.cart_update_url) return null;
    return theme.routes.cart_update_url;
  }

  function saveCartDeliveryAttributes(values) {
    var url = cartUpdateUrl();
    if (!url) return;
    var date = document.querySelector('#CartDeliveryDate');
    var time = document.querySelector('#CartDeliveryTime');
    var future = document.querySelector('#CartFutureRequests');
    var payload = values || {
      お届け日: date ? date.value : '',
      お届け時間帯: time ? time.value : '',
      今後欲しいアイテム: future ? future.value : ''
    };
    if (!values && (!date || !time)) return;
    Object.keys(LEGACY_CLEAR).forEach(function (key) {
      if (!(key in payload)) payload[key] = '';
    });
    fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json'
      },
      body: JSON.stringify({
        attributes: payload
      })
    });
  }

  function initCartDeliveryDatetime(root) {
    var scope = root && root.querySelector ? root : document;
    var clear = scope.querySelector('#CartDeliveryClear');
    if (clear) {
      if (clear.dataset.cleared === '1') return;
      clear.dataset.cleared = '1';
      saveCartDeliveryAttributes({
        お届け日: '',
        お届け時間帯: '',
        希望配送日: '',
        お届け希望時間: '',
        date: ''
      });
      return;
    }

    var date = scope.querySelector('#CartDeliveryDate');
    var time = scope.querySelector('#CartDeliveryTime');
    var legacy = scope.querySelector('#CartDeliveryLegacyClear');
    if (date && time && (date.dataset.synced !== '1' || legacy)) {
      date.dataset.synced = '1';
      if (legacy) legacy.remove();
      saveCartDeliveryAttributes();
    }
  }

  document.addEventListener('change', function (event) {
    var id = event.target && event.target.id;
    if (id === 'CartDeliveryDate' || id === 'CartDeliveryTime') {
      saveCartDeliveryAttributes();
    }
  });

  document.addEventListener('focusout', function (event) {
    if (event.target && event.target.id === 'CartFutureRequests') {
      saveCartDeliveryAttributes();
    }
  });

  function boot() {
    initCartDeliveryDatetime();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    initCartDeliveryDatetime(event.target);
  });
})();
